import * as React from 'react';

interface HelpSectionContextType {
    helpSlug: string | null;
    setHelpSlug: React.Dispatch<React.SetStateAction<string | null>>;
}

export const HelpSectionContext = React.createContext<HelpSectionContextType>({
    helpSlug: null,
    setHelpSlug: () => {},
});

/**
 * Hook for components to register which help article is contextually relevant.
 * Sets the slug on mount and clears it on unmount.
 *
 * Usage: useHelpSection('messaging-settings');
 */
export const useHelpSection = (slug: string) => {
    const { setHelpSlug } = React.useContext(HelpSectionContext);
    React.useEffect(() => {
        setHelpSlug(slug);
        return () => setHelpSlug(null);
    }, [slug, setHelpSlug]);
};
